import { Switch } from "@headlessui/react";

/**
 * The single toggle switch used across the settings UI. Headless UI `Switch`
 * styled to the Newsquawk theme, with a disabled state.
 */
export default function ToggleSwitch({
  checked,
  onChange,
  disabled = false,
  srLabel,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  srLabel: string;
}) {
  return (
    <Switch
      as="div"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className="group relative inline-flex w-12 p-1 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-squawk-blue focus-visible:ring-offset-2 data-[checked]:bg-squawk-blue data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50"
    >
      <span className="sr-only">{srLabel}</span>
      <span
        aria-hidden="true"
        className="pointer-events-none inline-block size-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
      />
    </Switch>
  );
}
